import type { SFAccount } from "../components/testSite/AccountPicker";

import { QueryParam } from "./permission.utils";

export const SF_IDENTIFIER_DELIMITER = "-";

export const sfAccountToIdentifier = (
    sfAccount: SFAccount | undefined,
): string => {
    if (sfAccount === undefined) return "";
    return [
        sfAccount[QueryParam.SALESFORCE_ID],
        sfAccount[QueryParam.MARKETPLACE_ID],
    ].join(SF_IDENTIFIER_DELIMITER);
};

export const sfIdentifierToAccount = (identifier: string): SFAccount => {
    const [salesforceId, marketplaceId] = identifier.split(
        SF_IDENTIFIER_DELIMITER,
    );

    return {
        [QueryParam.SALESFORCE_ID]: salesforceId,
        [QueryParam.MARKETPLACE_ID]: marketplaceId,
    };
};
